export const airDataTimeInterval: number = 60000; // 60 seconds
export const outdoorAirDataTimeInterval: number = 900000; // 15 minutes



// WEBPACK FOOTER //
// ./src/app/utils/time-interval.util.ts